import { HELP } from '@marvelapp/ballpark-help';
export function getMainLinks({ permissions, }) {
    return [
        {
            name: 'Projects',
            to: '/projects',
            canView: true,
        },
        {
            name: 'Archive',
            to: '/archive',
            canView: true,
        },
        {
            name: 'Team',
            to: '/company/people',
            canView: permissions.canViewPeople(),
        },
        {
            name: 'Team',
            to: '/company/guest',
            canView: !permissions.canViewPeople(),
        },
        {
            name: 'Templates',
            to: '/templates',
            canView: true,
        },
    ];
}
export const getHelpLinks = () => {
    return [
        {
            name: 'Help',
            to: HELP,
        },
        {
            name: 'Roadmap',
            to: 'https://portal.productboard.com/ballpark/1-ballpark',
            canView: true,
        },
        {
            name: 'Release notes',
            to: 'https://ballpark.frill.co/announcements',
        },
    ];
};
export const getUserBlockLinks = () => {
    return [
        {
            name: 'My account',
            to: '/user/account/personal',
        },
    ];
};
